import { actionConstants } from '../actions/actionConstants';

const initState = {
  loading: false,
  isFetching: false,
  isSubmitting: false,
  auditReports: [],
  getAuditReportsError: '',
  groupStatus: [],
  gSStatistics: [],
  limitsChanged: [],
  mktMonitors: [],
  getMktMonitorsError: '',
  mktMonitor: {},
  getMktMonitorError: {},
  createMktMonitorError: '',
  editMktMonitorError: '',
  deleteMktMonitorError: '',
  smLog: [],
  statisticsSummary: [],
  statisticsChart: [{}],
  statisticsDetails: [],
  trendChart: [],
  userNotes: [],
  error: '',
};

export default (state = initState, action) => {
  var _state = JSON.parse(JSON.stringify(state));
  switch (action.type) {
    case actionConstants.CLEAR_REPORT:
      return { ...initState };
    case actionConstants.START_QUERY_REPORT:
      _state.error = '';
      _state.loading = true;
      return _state;
    case actionConstants.END_QUERY_REPORT:
      _state.loading = false;
      return _state;
    case actionConstants.START_FETCHING:
      return { ...state, isFetching: true, error: '' };
    case actionConstants.END_FETCHING:
      return { ...state, isFetching: false };
    case actionConstants.START_SUBMISSION:
      _state.error = '';
      _state.isSubmitting = true;
      return _state;
    case actionConstants.END_SUBMISSION:
      _state.isSubmitting = false;
      return _state;
    case actionConstants.GETTING_REPORT:
      return { ...state, isFetching: true, error: '' };
    case actionConstants.GET_ALARM_HISTORY_SUCCESS:
      return { ...state, isFetching: false };
    case actionConstants.GET_ALARM_HISTORY_FAILURE:
      return { ...state, error: action.data, isFetching: false };
    case actionConstants.GET_AUDIT_REPORTS_SUCCESS:
      return { ...state, auditReports: action.data.items, isFetching: false };
    case actionConstants.GET_AUDIT_REPORTS_FAILURE:
      return { ...state, error: action.data, isFetching: false };
    case actionConstants.DOWNLOAD_BATCH_REPORT_SUCCESS:
      return { ...state, isFetching: false };
    case actionConstants.DOWNLOAD_BATCH_REPORT_FAILURE:
      return { ...state, error: action.data, isFetching: false };
    case actionConstants.GET_GROUP_STATUS_SUCCESS:
      return { ...state, isFetching: false };
    case actionConstants.GET_GROUP_STATUS_FAILURE:
      return { ...state, error: action.data, isFetching: false };
    case actionConstants.GET_GROUP_STATUS_STATISTICS_SUCCESS:
      return { ...state, isFetching: false };
    case actionConstants.GET_GROUP_STATUS_STATISTICS_FAILURE:
      return { ...state, error: action.data, isFetching: false };
    case actionConstants.GET_LIMITS_CHANGED_SUCCESS:
      return { ...state, isFetching: false };
    case actionConstants.GET_LIMITS_CHANGED_FAILURE:
      return { ...state, error: action.data, isFetching: false };
    case actionConstants.GET_MKT_MONITORS_SUCCESS:
      return { ...state, mktMonitors: action.data };
    case actionConstants.GET_MKT_MONITORS_FAILURE:
      return { ...state, error: action.data };
    case actionConstants.GET_MKT_MONITOR_SUCCESS:
      return { ...state, mktMonitor: action.data };
    case actionConstants.GET_MKT_MONITOR_FAILURE:
      return { ...state, getMktMonitorError: action.data };
    case actionConstants.CREATE_MKT_MONITOR_SUCCESS:
      return { ...state };
    case actionConstants.CREATE_MKT_MONITOR_FAILURE:
      return { ...state, error: action.data };
    case actionConstants.EDIT_MKT_MONITOR_SUCCESS:
      return { ...state };
    case actionConstants.EDIT_MKT_MONITOR_FAILURE:
      return { ...state, error: action.data };
    case actionConstants.DELETE_MKT_MONITOR_SUCCESS:
      return _state;
    case actionConstants.DELETE_MKT_MONITOR_FAILURE:
      _state.deleteMktMonitorError = action.data;
      return _state;
    case actionConstants.GET_SM_LOG_SUCCESS:
      return { ...state, isFetching: false };
    case actionConstants.GET_SM_LOG_FAILURE:
      return { ...state, error: action.data, isFetching: false };
    case actionConstants.GET_STATISTICS_SUMMARY_SUCCESS:
      return {
        ...state,
        isFetching: false,
        statisticsSummary: action.data,
      };
    case actionConstants.GET_STATISTICS_SUMMARY_FAILURE:
      return {
        ...state,
        isFetching: false,
        error: action.data,
      };
    case actionConstants.GET_STATISTICS_CHART_SUCCESS:
      return { ...state, isFetching: false, statisticsChart: action.data };
    case actionConstants.GET_STATISTICS_CHART_FAILURE:
      return { ...state, isFetching: false, error: action.data };
    case actionConstants.GET_STATISTICS_DETAILS_SUCCESS:
      return { ...state, isFetching: false, statisticsDetails: action.data };
    case actionConstants.GET_STATISTICS_DETAILS_FAILURE:
      return { ...state, isFetching: false, error: action.data };
    case actionConstants.GET_TREND_CHART_SUCCESS:
      return { ...state, trendChart: action.data, isFetching: false };
    case actionConstants.GET_TREND_CHART_FAILURE:
      return { ...state, error: action.data, isFetching: false };
    case actionConstants.GET_USER_NOTES_SUCCESS:
      return { ...state, isFetching: false };
    case actionConstants.GET_USER_NOTES_FAILURE:
      return { ...state, error: action.data, isFetching: false };
    default:
      return _state;
  }
};
